import { render } from "./templateDetails.vue?vue&type=template&id=230b2710&scoped=true&ts=true"
import script from "./templateDetails.vue?vue&type=script&lang=ts"
export * from "./templateDetails.vue?vue&type=script&lang=ts"

import "./templateDetails.vue?vue&type=style&index=0&id=230b2710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230b2710"]])

export default __exports__